type StorageType = 'session' | 'local';
type UseStorageReturnValue = {
  getItem: (key: string, type?: StorageType) => string | null;
  setItem: (key: string, value: string, type?: StorageType) => boolean;
  removeItem: (key: string, type?: StorageType) => void;
};

const useBrowserStorage = (): UseStorageReturnValue => {
  const isBrowser: boolean = ((): boolean => typeof window !== 'undefined')();

  const getItem = (key: string, type?: StorageType): string | null => {
    const storageType = type ?? 'session';
    if(isBrowser) {
      if(storageType == 'session') {
        return sessionStorage.getItem(key);
      }
      else {
        return localStorage.getItem(key);
      }
    }
    else {
      return null;
    }
  };

  const setItem = (key: string, value: string, type?: StorageType): boolean => {
    const storageType = type ?? 'session';
    if (isBrowser) {
      if(storageType == 'session') {
        sessionStorage.setItem(key, value);
      }
      else {
        localStorage.setItem(key, value);
      }
      return true;
    }
    return false;
  };

  const removeItem = (key: string, type?: StorageType): void => {
    const storageType = type ?? 'session';
    if(isBrowser) {
      if(storageType == 'session') {
        sessionStorage.removeItem(key);
      }
      else {
        localStorage.removeItem(key);
      }
    }
  };

  return {
    getItem,
    setItem,
    removeItem,
  };
};

export default useBrowserStorage;